// Shared plant database for frontend
// This will be replaced by API calls when backend is connected

export const PLANT_DATABASE = [
  {
    id: 'tomato',
    name: 'Tomato',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 11,
    spacing: 24,
    companionIds: ['basil', 'marigold'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-10-15',
    image: '🍅'
  },
  {
    id: 'lettuce',
    name: 'Lettuce',
    type: 'vegetable',
    sun: 'partial',
    soil: 'moist',
    zoneMin: 2,
    zoneMax: 11,
    spacing: 6,
    companionIds: ['carrot', 'radish'],
    plantingStart: '2024-02-15',
    plantingEnd: '2024-04-30',
    harvestStart: '2024-04-15',
    harvestEnd: '2024-06-30',
    image: '🥬'
  },
  {
    id: 'carrot',
    name: 'Carrot',
    type: 'vegetable',
    sun: 'full',
    soil: 'loose',
    zoneMin: 3,
    zoneMax: 10,
    spacing: 3,
    companionIds: ['lettuce', 'onion'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-08-15',
    image: '🥕'
  },
  {
    id: 'basil',
    name: 'Basil',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 11,
    spacing: 12,
    companionIds: ['tomato'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-09-30',
    image: '🌿'
  },
  {
    id: 'marigold',
    name: 'Marigold',
    type: 'flower',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 11,
    spacing: 8,
    companionIds: ['tomato', 'pepper'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-10-31',
    image: '🌼'
  },
  {
    id: 'pepper',
    name: 'Bell Pepper',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 11,
    spacing: 18,
    companionIds: ['marigold', 'basil'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-07-15',
    harvestEnd: '2024-10-15',
    image: '🫑'
  },
  {
    id: 'onion',
    name: 'Onion',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 4,
    companionIds: ['carrot', 'lettuce'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-04-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-08-15',
    image: '🧅'
  },
  {
    id: 'radish',
    name: 'Radish',
    type: 'vegetable',
    sun: 'full',
    soil: 'loose',
    zoneMin: 2,
    zoneMax: 11,
    spacing: 2,
    companionIds: ['lettuce', 'carrot'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-04-15',
    harvestEnd: '2024-06-01',
    image: '🔴'
  },
  {
    id: 'cucumber',
    name: 'Cucumber',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 11,
    spacing: 36,
    companionIds: ['beans', 'corn', 'sunflower'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-09-30',
    image: '🥒'
  },
  {
    id: 'beans',
    name: 'Green Beans',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 10,
    spacing: 6,
    companionIds: ['corn', 'cucumber', 'potato'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-07-01',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-09-15',
    image: '🫘'
  },
  {
    id: 'corn',
    name: 'Sweet Corn',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 8,
    spacing: 12,
    companionIds: ['beans', 'cucumber', 'squash'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-07-15',
    harvestEnd: '2024-09-15',
    image: '🌽'
  },
  {
    id: 'potato',
    name: 'Potato',
    type: 'vegetable',
    sun: 'full',
    soil: 'loose',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 12,
    companionIds: ['beans', 'cabbage', 'marigold'],
    plantingStart: '2024-03-15',
    plantingEnd: '2024-05-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-09-30',
    image: '🥔'
  },
  {
    id: 'cabbage',
    name: 'Cabbage',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 9,
    spacing: 18,
    companionIds: ['potato', 'onion', 'marigold'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-08-15',
    image: '🥬'
  },
  {
    id: 'spinach',
    name: 'Spinach',
    type: 'vegetable',
    sun: 'partial',
    soil: 'moist',
    zoneMin: 2,
    zoneMax: 9,
    spacing: 4,
    companionIds: ['strawberry', 'radish', 'lettuce'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-04-15',
    harvestEnd: '2024-06-15',
    image: '🥬'
  },
  {
    id: 'strawberry',
    name: 'Strawberry',
    type: 'fruit',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 10,
    spacing: 18,
    companionIds: ['spinach', 'lettuce', 'thyme'],
    plantingStart: '2024-03-15',
    plantingEnd: '2024-05-15',
    harvestStart: '2024-05-15',
    harvestEnd: '2024-07-15',
    image: '🍓'
  },
  {
    id: 'thyme',
    name: 'Thyme',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 5,
    zoneMax: 9,
    spacing: 12,
    companionIds: ['strawberry', 'tomato', 'cabbage'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-09-30',
    image: '🌿'
  },
  {
    id: 'oregano',
    name: 'Oregano',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 9,
    spacing: 12,
    companionIds: ['tomato', 'pepper', 'basil'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-09-30',
    image: '🌿'
  },
  {
    id: 'mint',
    name: 'Mint',
    type: 'herb',
    sun: 'partial',
    soil: 'moist',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 18,
    companionIds: ['cabbage', 'tomato'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-09-30',
    image: '🍃'
  },
  {
    id: 'sunflower',
    name: 'Sunflower',
    type: 'flower',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 11,
    spacing: 24,
    companionIds: ['cucumber', 'corn', 'beans'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-08-01',
    harvestEnd: '2024-10-15',
    image: '🌻'
  },
  {
    id: 'zucchini',
    name: 'Zucchini',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 36,
    companionIds: ['corn', 'beans', 'marigold'],
    plantingStart: '2024-05-01',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-09-30',
    image: '🥒'
  },
  {
    id: 'broccoli',
    name: 'Broccoli',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 18,
    companionIds: ['onion', 'marigold', 'thyme'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-08-15',
    image: '🥦'
  },
  {
    id: 'peas',
    name: 'Garden Peas',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 9,
    spacing: 3,
    companionIds: ['carrot', 'radish', 'corn'],
    plantingStart: '2024-02-15',
    plantingEnd: '2024-04-15',
    harvestStart: '2024-05-15',
    harvestEnd: '2024-07-15',
    image: '🫛'
  },
  {
    id: 'squash',
    name: 'Summer Squash',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 36,
    companionIds: ['corn', 'beans', 'marigold'],
    plantingStart: '2024-05-01',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-07-01',
    harvestEnd: '2024-09-30',
    image: '🥒'
  },
  {
    id: 'eggplant',
    name: 'Eggplant',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 10,
    spacing: 24,
    companionIds: ['basil', 'marigold', 'pepper'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-07-15',
    harvestEnd: '2024-09-30',
    image: '🍆'
  },
  {
    id: 'cauliflower',
    name: 'Cauliflower',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 9,
    spacing: 18,
    companionIds: ['onion', 'marigold', 'thyme'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-08-15',
    image: '🥦'
  },
  {
    id: 'kale',
    name: 'Kale',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 9,
    spacing: 12,
    companionIds: ['onion', 'marigold', 'herbs'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-05-15',
    harvestEnd: '2024-11-15',
    image: '🥬'
  },
  {
    id: 'rosemary',
    name: 'Rosemary',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 6,
    zoneMax: 10,
    spacing: 24,
    companionIds: ['sage', 'thyme', 'cabbage'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-12-31',
    image: '🌿'
  },
  {
    id: 'sage',
    name: 'Sage',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 4,
    zoneMax: 9,
    spacing: 18,
    companionIds: ['rosemary', 'thyme', 'cabbage'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-10-31',
    image: '🌿'
  },
  {
    id: 'chives',
    name: 'Chives',
    type: 'herb',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 3,
    zoneMax: 9,
    spacing: 8,
    companionIds: ['carrot', 'tomato', 'cabbage'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-05-01',
    harvestEnd: '2024-10-31',
    image: '🧄'
  },
  {
    id: 'lavender',
    name: 'Lavender',
    type: 'flower',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 5,
    zoneMax: 9,
    spacing: 24,
    companionIds: ['rosemary', 'sage', 'thyme'],
    plantingStart: '2024-04-01',
    plantingEnd: '2024-06-01',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-08-15',
    image: '💜'
  },
  {
    id: 'nasturtium',
    name: 'Nasturtium',
    type: 'flower',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 11,
    spacing: 12,
    companionIds: ['cucumber', 'tomato', 'radish'],
    plantingStart: '2024-04-15',
    plantingEnd: '2024-06-15',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-09-30',
    image: '🌺'
  },
  {
    id: 'beets',
    name: 'Beets',
    type: 'vegetable',
    sun: 'full',
    soil: 'well-drained',
    zoneMin: 2,
    zoneMax: 10,
    spacing: 4,
    companionIds: ['onion', 'cabbage', 'lettuce'],
    plantingStart: '2024-03-01',
    plantingEnd: '2024-05-01',
    harvestStart: '2024-06-01',
    harvestEnd: '2024-08-15',
    image: '🟤'
  },
  {
    id: 'blueberries',
    name: 'Blueberries',
    type: 'fruit',
    sun: 'full',
    soil: 'acidic',
    zoneMin: 3,
    zoneMax: 8,
    spacing: 48,
    companionIds: ['strawberry'],
    plantingStart: '2024-03-15',
    plantingEnd: '2024-05-15',
    harvestStart: '2024-06-15',
    harvestEnd: '2024-08-15',
    image: '🫐'
  }
];

export default PLANT_DATABASE;